import { Gender } from 'interfaces/types'
import { ageGenerate } from 'utils/ageGenerate'

import { BABY_GROWTH_ACTION } from './actions'
import { babyGrowthInitialState } from './initialState'
import { BabyGrowthAction, BabyGrowthState } from './types'

export const babyGrowthReducer = (
  state: BabyGrowthState = babyGrowthInitialState,
  action: BabyGrowthAction,
): BabyGrowthState => {
  switch (action.type) {
    case BABY_GROWTH_ACTION.SUBMIT: {
      const age = ageGenerate(
        action.payload.birthday,
        action.payload.measurementDate,
      )
      return {
        ...state,
        ...action.payload,
        age,
      }
    }

    case BABY_GROWTH_ACTION.UPDATE_CONTENT: {
      return {
        ...state,
        babyGrowthContent: action.payload,
      }
    }

    case BABY_GROWTH_ACTION.UPDATE_RESULT: {
      return {
        ...state,
        babyGrowthResult: action.payload,
      }
    }

    case BABY_GROWTH_ACTION.UPDATE_RESULT_BASED_ON_RISK_LEVEL: {
      return {
        ...state,
        riskLevel: action.payload.riskLevel,
        resultBasedOnRiskLevel: action.payload.content,
      }
    }

    case BABY_GROWTH_ACTION.RE_CALCULATE: {
      return {
        ...state,
        name: '',
        gender: Gender.Boy,
        birthday: new Date(),
        height: 0,
        weight: 0,
        head: 0,
        bmi: 0,
        measurementDate: new Date(),
        resultBasedOnRiskLevel: null,
      }
    }

    case BABY_GROWTH_ACTION.UPDATE_BABY_LIST: {
      return {
        ...state,
        babyLists: action.payload,
      }
    }

    case BABY_GROWTH_ACTION.IS_NEW_BABY: {
      return {
        ...state,
        isNewBaby: action.payload,
      }
    }

    case BABY_GROWTH_ACTION.CURRENT_BABY: {
      return {
        ...state,
        currentBaby: action.payload,
      }
    }
    default:
      return state
  }
}
